import React, { useMemo, useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
  GetAllItensDaMedicoes,
  GetObterMedicaoPorId,
  MedicaoEdit,
  EditarMedicao,
  GetAllAnexoMedicaoEditMedicao,
  updateDescricaoAnexoBm,
  updatePeriodoMedicao,
  ReprovarCancelamentoBm,
  SolicitarCancelamentoBoletimMedicao,
  ConfirmarMedicao,
  RefutarMedicao,
  UpdateAprovarReprovar,
  DownloadAnexoMedidas,
  DeletarAnexoBmMedicaoPorId,
  GetAllTotalizarMedicao,
  medicaoConfirmadaOptions,
  ViewArquivoAnexoMedidas,
  AprovarCancelamentoBm,
} from '@app/api/boletimMedicao';
import {
  formularoReprovacaoAprovacao,
  realizarAprovacaoNivel1,
  realizarReprovacaoNivel1,
  realizarReprovacaoNivel3,
  realizarAprovacaoNivel3,
  realizarReprovacaoNivel2,
  realizarAprovacaoNivel2,
} from '@app/api/boletimMedicaoAprovocaoPagamento';
import { GetFileExtension, getLoggedIsMRN, imageFormats } from '@app/helpers';
import { currencyFormat } from '@app/helpers/numbers';
import { hasPermission } from '@app/helpers/permissions';
import {
  Widget,
  usePromise,
  MasterDetailForm,
  FormSubmitButton,
  FormatText,
  FormInput,
  FormDatePicker,
  FormSwitch,
  FormTextArea,
  InlineEditTable,
  Icon,
  Button,
  ButtonDelete,
  useRouter,
  FormSelect,
  Row,
} from '@digital/ui';
import { Collapse, Tooltip } from 'antd';

import ComponeteCurso from '../../../components/componeteCurso';
import ModalJustificativaCancelamentoMedicao from '../Medicao/ModalJustificativaCancelamentoMedicao';
import ModalJustificativaCancelamentoMedicaoPeloDropdown from '../Medicao/ModalJustificativaCancelamentoMedicaoPeloDropdown';
import TotalizadorMedicao from '../TotalizadorMedicao';
import { Visibility } from '@app/components/Visibility';
import { useRecoilValue } from 'recoil';
import { medicaoSelectedState } from '../atoms';

interface MedicaoFormProps {
  onUpdate: () => any;
  onUpdatePage: () => any;
  atualizarFormularioAbas: () => any;
  atualizarFormulario: boolean;
  atualizarSla: boolean;
  usuarioPodeEditar: boolean;

  usuarioLogadoGestorDoContratoMrn: boolean;
  usuarioLogadoFiscalDoContratoMrn: boolean;
  usuarioLogadoFiscalAlternativoDoContratoMrn: boolean;
  usuarioLogadoAdministradorAlternativoDoContratoMrn: boolean;
  usuarioLogadoAdministradorDoContratoMrn: boolean;
  usuarioLogadoFiscalDoContratoFornecedor: boolean;
  usuarioLogadoGestorDoContratoFornecedor: boolean;
  usuarioLogadoTecnicoMedicaoMrn: boolean;

  usuarioResponsavelDiretoriaProp: boolean;
  usuarioResponsavelAreaProp: boolean;
  usuarioResponsavelDepartamentoProp: boolean;

  codigoStatusMedicao: number;
  onCreateAba: () => any;
  onRemoveAba: () => any;
}

const Medicao = (props: MedicaoFormProps) => {
  const {
    onUpdate,
    atualizarSla,
    onUpdatePage,
    atualizarFormularioAbas,
    atualizarFormulario,
    usuarioPodeEditar,

    usuarioLogadoGestorDoContratoMrn,
    usuarioLogadoFiscalDoContratoMrn,
    usuarioLogadoFiscalAlternativoDoContratoMrn,
    usuarioLogadoAdministradorAlternativoDoContratoMrn,
    usuarioLogadoAdministradorDoContratoMrn,
    usuarioLogadoFiscalDoContratoFornecedor,
    usuarioLogadoGestorDoContratoFornecedor,
    usuarioLogadoTecnicoMedicaoMrn,
    codigoStatusMedicao,

    usuarioResponsavelDiretoriaProp,
    usuarioResponsavelAreaProp,
    usuarioResponsavelDepartamentoProp,
    onCreateAba,
    onRemoveAba,
  } = props;

  const { history } = useRouter();
  const medicaoSelected = useRecoilValue(medicaoSelectedState);

  useEffect(() => {
    onRemoveAba();
  }, [medicaoSelected]);

  const { Panel } = Collapse;
  const [itemAdded, setItemAdded] = useState();

  const [isMRN] = useState<boolean>(getLoggedIsMRN());

  const [hasBtnAprovarDadosBM, setBtnAprovarDadosBM] = useState(false);
  const [hasBtnAprovarDadosBmComRessalva, setBtnAprovarDadosBmComRessalva] = useState(false);
  const [hasBtnRefutarMedicao, setBtnRefutarMedicao] = useState(false);
  const [hasbtnReprovarOuAprovarQuantidadeDoPeriodo, setReprovarOuAprovarQuantidadeDoPeriodo] = useState(false);

  const [hasBtnConfirmarMedicao, setBtnConfirmarMedicao] = useState(false);
  const [hasBtnSolicitarCancelamentoBoletimMedicao, setBtnSolicitarCancelamentoBoletimMedicao] = useState(false);
  const [hasBtnAprovarCancelamentoBm, setBtnAprovarCancelamentoBm] = useState(false);
  const [hasBtnReprovarCancelamentoBm, setBtnReprovarCancelamentoBm] = useState(false);

  const [hasBtnReprovarDadosQuantativos, setBtnReprovarDadosQuantativos] = useState(false);
  const [hasBtnConfirmarQuantidadeDoBm, setBtnConfirmarQuantidadeDoBm] = useState(false);
  const [hasBtnAprovarAnaliseQuantitativaBm, setBtnAprovarAnaliseQuantitativaBm] = useState(false);
  const [hasBtnReprovarAnaliseQuantitativaBm, setBtnReprovarAnaliseQuantitativaBm] = useState(false);
  const [hasBtnAprovarComRessalvaAnaliseQuantitativa, setBtnAprovarComRessalvaAnaliseQuantitativa] = useState(false);
  const [hasBtnRefutarAnaliseQuantitativa, setBtnRefutarAnaliseQuantitativa] = useState(false);
  const [hasBtnReconfirmarQuantidadeBm, setBtnReconfirmarQuantidadeBm] = useState(false);

  const [recarregarBotoesGrid, setRecarregarBotoesGrid] = useState(false);

  const [inclusaoValor, setinclusaoValor] = useState();
  const [editAnterior, seteditAnterior] = useState(false);
  const [idEdit, setidEdit] = useState();

  const [recarregarBotoesBm, setrecarregarBotoesBm] = useState(false);
  const [valorAlterado, setValorAlterado] = useState();

  const [codStatusMedicao, setcodigoStatusMedicao] = useState(0);

  const [valoresContratoCriacaoMedicao, setvaloresContratoCriacaoMedicao] = useState('0');
  const [valoresMedicaoAnterior, setvaloresMedicaoAnterior] = useState('0');
  const [valoresMedicaoPeriodo, setvaloresMedicaoPeriodo] = useState('0');
  const [valoresMedicaoAcumulado, setvaloresMedicaoAcumulado] = useState('0');
  const [valoreMedicaoSaldo, setvaloreMedicaoSaldo] = useState('0');

  const [expandedRows, setExpandedRows] = useState(['']);
  const [expandableRows, setExpandableRows] = useState(['']);
  const [btnExpandRows, setBtnExpandRows] = useState(true);
  const [medicaoConfirmada, setMedicaoConfirmada] = useState<boolean>();
  const [showModalCancelarMedicao, setShowModalCancelarMedicao] = useState(false);
  const [canChangeCancelarDropdown, setCanChangeCancelarDropdown] = useState(false);

  const obterTotalMedicao = () => {

    GetAllTotalizarMedicao(medicaoSelected.id).then(data => {
      if (data) {
        if (data.medicaoAnterior != undefined) {
          setvaloresMedicaoAnterior(currencyFormat(data.medicaoAnterior));
        }

        if (data.medicaoPeriodo != undefined) {
          setvaloresMedicaoPeriodo(currencyFormat(data.medicaoPeriodo));
        }

        if (data.medicaoAcumulado != undefined) {
          setvaloresMedicaoAcumulado(currencyFormat(data.medicaoAcumulado));
        }
        if (data.medicaoSaldo != undefined) {
          setvaloreMedicaoSaldo(currencyFormat(data.medicaoSaldo));
        }
        if (data.medicaoValorContratoCriacao != undefined) {
          setvaloresContratoCriacaoMedicao(currencyFormat(data.medicaoValorContratoCriacao));
        }
      }
    });
  };

  const calculateDefaultExpandedRowKeys = (data: any[]) => {
    const keys: string[] = [];
    const mapRowKeys = (source: any[]) => {
      source.forEach(element => {
        if (element.children.length !== 0) {
          mapRowKeys(element.children);
          keys.push(element.id);
        }
      });
    };
    mapRowKeys(data);
    return keys;
  };

  const toggleEdit = (record: any) => {
    setidEdit(record.id);
    seteditAnterior(true);
  };

  const save = (record: any, e: any) => {
    const valor = e.target.value;

    const form = new FormData();
    form.append('id', record.id);
    form.append('qt_bl_periodo', valor);

    updatePeriodoMedicao(record.id, form).then(data => {
      if (data) {
        if (data.valid) {
          seteditAnterior(false);
          setinclusaoValor('');
          setinclusaoValor(true);
          obterTotalMedicao();
        }
      }
      return data;
    });
  };
  const cancelar = () => {
    seteditAnterior(false);
  };

  const updateMedicaoConfirmada = (confirmada: boolean) => {
    if (confirmada === true) {
      setMedicaoConfirmada(true);
      setShowModalCancelarMedicao(false);
    } else if (confirmada === false) {
      setMedicaoConfirmada(false);
      setShowModalCancelarMedicao(true);
    }
  };

  const AprovarOuReprovar = (id: any, value: any) => {
    if (value != null) {
      const form = new FormData();
      form.append('id', id);
      form.append('Acao', value);

      UpdateAprovarReprovar(form).then(data => {
        if (data) {
          if (data.valid) {
          }
        }
        return data;
      });
    }
  };

  const [getAllItensDaMedicoes] = usePromise(
    () =>
      medicaoSelected
        ? GetAllItensDaMedicoes(medicaoSelected.id).then(data => {
          if (data) {
            if (expandableRows[0] === '') setExpandableRows(calculateDefaultExpandedRowKeys(data));
          }
          return data;
        })
        : Promise.resolve(undefined),
    [itemAdded, inclusaoValor, medicaoSelected, atualizarSla],
    [],
  );

  useEffect(() => {
    if (!btnExpandRows) setExpandedRows(expandableRows);
    else setExpandedRows([]);
  }, [btnExpandRows, expandableRows]);

  const [geralData] = usePromise(
    () =>
      medicaoSelected
        ? GetObterMedicaoPorId(medicaoSelected.id).then(data => {
          if (data) {
            setcodigoStatusMedicao(data.statusCodigo);
            if (data.confirmada === undefined) setCanChangeCancelarDropdown(true);
            else setCanChangeCancelarDropdown(false);
            setMedicaoConfirmada(data.confirmada);

            if (data.reprovarDadosQuantitativos) {
              setBtnReprovarDadosQuantativos(true);
            } else {
              setBtnReprovarDadosQuantativos(false);
            }
            if (data.confirmarQuantidadeDoBm) {
              setBtnConfirmarQuantidadeDoBm(true);
            } else {
              setBtnConfirmarQuantidadeDoBm(false);
            }
            if (data.aprovarAnaliseQuantitativaBm) {
              setBtnAprovarAnaliseQuantitativaBm(true);
            } else {
              setBtnAprovarAnaliseQuantitativaBm(false);
            }
            if (data.reprovarAnaliseQuantitativaBm) {
              setBtnReprovarAnaliseQuantitativaBm(true);
            } else {
              setBtnReprovarAnaliseQuantitativaBm(false);
            }

            if (data.aprovarComRessalvaAnaliseQuantitativa === true && data.mostrarBotaoAprovarComResalva === true) {
              setBtnAprovarComRessalvaAnaliseQuantitativa(true);
            } else {
              setBtnAprovarComRessalvaAnaliseQuantitativa(false);
            }
            if (data.refutarAnaliseQuantitativa) {
              setBtnRefutarAnaliseQuantitativa(true);
            } else {
              setBtnRefutarAnaliseQuantitativa(false);
            }
            if (data.reconfirmarQuantidadeBm) {
              setBtnReconfirmarQuantidadeBm(true);
            } else {
              setBtnReconfirmarQuantidadeBm(false);
            }

            if (data.aprovarDadosBM) {
              setBtnAprovarDadosBM(true);
            } else {
              setBtnAprovarDadosBM(false);
            }
            if (data.aprovarDadosBmComRessalva && data.mostrarBotaoAprovarComResalva === true) {
              setBtnAprovarDadosBmComRessalva(true);
            } else {
              setBtnAprovarDadosBmComRessalva(false);
            }

            if (data.refutarMedicao) {
              setBtnRefutarMedicao(true);
            } else {
              setBtnRefutarMedicao(false);
            }

            if (data.reprovarQuantidadeDoPeriodo) {
              setReprovarOuAprovarQuantidadeDoPeriodo(true);
            } else {
              setReprovarOuAprovarQuantidadeDoPeriodo(false);
            }

            if (data.confirmarMedicao) {
              setBtnConfirmarMedicao(true);
            } else {
              setBtnConfirmarMedicao(false);
            }

            if (data.solicitarCancelamentoBoletimMedicao) {
              setBtnSolicitarCancelamentoBoletimMedicao(true);
            } else {
              setBtnSolicitarCancelamentoBoletimMedicao(false);
            }

            if (data.aprovarCancelamentoBm) {
              setBtnAprovarCancelamentoBm(true);
            } else {
              setBtnAprovarCancelamentoBm(false);
            }

            if (data.reprovarCancelamentoBm) {
              setBtnReprovarCancelamentoBm(true);
            } else {
              setBtnReprovarCancelamentoBm(false);
            }
            obterTotalMedicao();
          }

          setRecarregarBotoesGrid(false);
          setRecarregarBotoesGrid(true);
          return data;
        })
        : Promise.resolve(undefined),
    [medicaoSelected, itemAdded, recarregarBotoesBm, atualizarSla, atualizarFormulario],
    {} as MedicaoEdit,
  );

  const [getAllAnexoMedicoesPorMedicaoId] = usePromise(
    () => (medicaoSelected ? GetAllAnexoMedicaoEditMedicao(medicaoSelected.id) : Promise.resolve(undefined)),
    [itemAdded, medicaoSelected, atualizarSla],
    [],
  );

  const CarregarGrid = () => {
    setItemAdded(null);
    setItemAdded(true);
  };

  const columsAnexosDamedicao = [
    {
      title: 'N',
      dataIndex: 'numero',
      editable: { inputType: 'text' },
      width: '2%',
    },
    {
      title: 'Arquivo',
      dataIndex: 'nomeDoArquivo',
      editable: { inputType: 'text' },
      width: '25%',
    },
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      renderEdit: (text, record) => {
        if (codStatusMedicao != 7 && codStatusMedicao != 8) return <FormInput name="descricao" />;
        else return record.descricao;
      },
      width: '30%',
    },
    {
      title: 'Inclusão',
      dataIndex: 'dataHoraInclusao',
      editable: { inputType: 'text' },
      width: '10%',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      editable: { inputType: 'text' },
      width: '20%',
    },
    {
      title: 'Opções',
      dataIndex: 'acoes',
      width: '10%',
      render: (text, record, index) => {
        if (true) {
          return (
            <>
              <Tooltip title="Baixar Arquivo">
                <Button
                  onClick={() => {
                    DownloadAnexoMedidas(record.id, record.nomeDoArquivo);
                  }}
                  icon="ui-download"
                />
              </Tooltip>
              {GetFileExtension(record.nomeDoArquivo) === 'pdf' ||
                imageFormats.includes(GetFileExtension(record.nomeDoArquivo)) ? (
                <Tooltip title="Visualizar Arquivo">
                  <Button
                    onClick={async () => {
                      await ViewArquivoAnexoMedidas(record.id, record.nomeDoArquivo);
                    }}
                    icon="files-view_file"
                    name="btnViewArquivo"
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {codStatusMedicao != 7 &&
                codStatusMedicao != 8 &&
                (isMRN ||
                  ((codStatusMedicao === 1 || codStatusMedicao === 3) && // codigo 1 = Aguardando Forncedor    codigo 3 = Aguardando correção do fornecedor
                    (usuarioLogadoFiscalDoContratoFornecedor === true ||
                      usuarioLogadoGestorDoContratoFornecedor === true))) ? (
                <Tooltip title="Deletar Item">
                  <ButtonDelete
                    icon="science-minus"
                    type="link"
                    confirm="Deseja realmente excluir este registro?"
                    okText="Confirmar"
                    onClick={() => handleDelete(record.id)}
                    className="btn-delete-without-text"
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          );
        }
      },
    },
  ];

  const handleDelete = (values: any) =>
    DeletarAnexoBmMedicaoPorId(values).then(resp => {
      if (resp.valid) {
        CarregarGrid();
      }
    });

  const actionAnexosDamedicao = useMemo(() => {
    const actions = [];

    if (
      hasPermission(['MEDICAO_QUANTITATIVA_CADASTRAR_ANEXO']) &&
      (isMRN ||
        ((codStatusMedicao === 1 || codStatusMedicao === 3) && // codigo 1 = Aguardando Forncedor    codigo 3 = Aguardando correção do fornecedor
          (usuarioLogadoFiscalDoContratoFornecedor === true || usuarioLogadoGestorDoContratoFornecedor === true)))
    ) {
      actions.push(
        <ComponeteCurso
          id={medicaoSelected.id}
          nomeIdFormulario={'medicaoId'}
          enderecoApi={'medicao/updateAnexoMedicao'}
          descricaoBotao={'Cadastrar Anexo da Medição'}
          retorno={CarregarGrid}
          idDoComponente="anexomMedicao"
        />,
      );
    }

    return actions;
  }, [geralData, medicaoSelected, atualizarSla]);

  const pqActionDadosGerais = useMemo(() => {
    const actions = [];

    if (hasPermission(['MEDICAO_QUANTITATIVA_REFUTAR_MEDICAO']) && usuarioPodeEditar === true) {
      if (hasBtnRefutarMedicao) {
        actions.push(
          <Button
            type="danger"
            icon="hands-thumbs_down"
            onClick={() => {
              RefutarMedicao(medicaoSelected.id).then(data => {
                if (data) {
                  if (data.valid) {
                    onUpdatePage();
                  }
                }
              });
            }}>
            Refutar Medição
          </Button>,
        );
      }
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_CONFIRMAR_MEDICAO']) && usuarioPodeEditar === true) {
      if (hasBtnConfirmarMedicao) {
        actions.push(
          <Button
            type="success"
            icon="hands-thumbs_up"
            onClick={() => {
              ConfirmarMedicao(medicaoSelected.id).then(data => {
                if (data) {
                  if (data.valid) {
                    onUpdatePage();
                  }
                }
              });
            }}>
            Confirmar Medição
          </Button>,
        );
      }
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_SOLICITAR_CANCELAMENTO']) && usuarioLogadoGestorDoContratoMrn === true) {
      if (hasBtnSolicitarCancelamentoBoletimMedicao) {
        actions.push(
          <ModalJustificativaCancelamentoMedicao
            id={medicaoSelected.id}
            onUpdatePage={onUpdatePage}
            step={1}
            justificativaCancelamento={medicaoSelected.justificativaCancelamento}
          />,
        );
      }
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_APROVAR_CANCELAMENTO'])) {
      if (hasBtnAprovarCancelamentoBm) {
        actions.push(
          <ModalJustificativaCancelamentoMedicao
            id={medicaoSelected.id}
            onUpdatePage={onUpdatePage}
            step={2}
            justificativaCancelamento={medicaoSelected.justificativaCancelamento}
          />
        );
      }
    }

    if (hasPermission(['MEDICAO_QUANTITATIVA_REPROVAR_CANCELAMENTO'])) {
      if (hasBtnReprovarCancelamentoBm && usuarioLogadoAdministradorDoContratoMrn) {
        actions.push(
          <Button
            type="success"
            icon="files-check_file_filled2"
            onClick={() => {
              ReprovarCancelamentoBm(medicaoSelected.id).then(data => {
                if (data) {
                  if (data.valid) {
                    onUpdatePage();
                  }
                }
              });
            }}>
            Manter BM
          </Button>,
        );
      }
    }

    if (
      hasPermission(['MEDICAO_NDA_N1_APROVAR_REPROVAR']) &&
      codStatusMedicao === 10 &&
      isMRN &&
      usuarioResponsavelDepartamentoProp
    ) {
      actions.push(
        <Button
          type="success"
          onClick={() => {
            if (medicaoSelected) {
              const form = { medicaoId: medicaoSelected.id, nivel: 1 } as formularoReprovacaoAprovacao;
              realizarAprovacaoNivel1(form).then(resultData => {
                if (resultData) {
                  onUpdatePage();
                }
              });
            }
          }}>
          APROVAR
        </Button>,
      );

      actions.push(
        <Button
          type="danger"
          onClick={() => {
            if (medicaoSelected) {
              const form = { medicaoId: medicaoSelected.id, nivel: 1 } as formularoReprovacaoAprovacao;
              realizarReprovacaoNivel1(form).then(resultData => {
                if (resultData) {
                  onUpdatePage();
                }
              });
            }
          }}>
          REPROVAR
        </Button>,
      );
    }

    if (
      hasPermission(['MEDICAO_NDA_N2_APROVAR_REPROVAR']) &&
      codStatusMedicao === 11 &&
      isMRN &&
      usuarioResponsavelAreaProp
    ) {
      actions.push(
        <Button
          type="success"
          onClick={() => {
            if (medicaoSelected) {
              const form = { medicaoId: medicaoSelected.id, nivel: 2 } as formularoReprovacaoAprovacao;
              realizarAprovacaoNivel2(form).then(resultData => {
                if (resultData) {
                  onUpdatePage();
                }
              });
            }
          }}>
          APROVAR
        </Button>,
      );

      actions.push(
        <Button
          type="danger"
          onClick={() => {
            if (medicaoSelected) {
              const form = { medicaoId: medicaoSelected.id, nivel: 2 } as formularoReprovacaoAprovacao;
              realizarReprovacaoNivel2(form).then(resultData => {
                if (resultData) {
                  onUpdatePage();
                }
              });
            }
          }}>
          REPROVAR
        </Button>,
      );
    }

    if (
      hasPermission(['MEDICAO_NDA_N3_APROVAR_REPROVAR']) &&
      codStatusMedicao === 12 &&
      isMRN &&
      usuarioResponsavelDiretoriaProp
    ) {
      actions.push(
        <Button
          type="success"
          onClick={() => {
            if (medicaoSelected) {
              const form = { medicaoId: medicaoSelected.id, nivel: 3 } as formularoReprovacaoAprovacao;
              realizarAprovacaoNivel3(form).then(resultData => {
                if (resultData) {
                  onUpdatePage();
                }
              });
            }
          }}>
          APROVAR
        </Button>,
      );

      actions.push(
        <Button
          type="danger"
          onClick={() => {
            if (medicaoSelected) {
              const form = { medicaoId: medicaoSelected.id, nivel: 3 } as formularoReprovacaoAprovacao;
              realizarReprovacaoNivel3(form).then(resultData => {
                if (resultData) {
                  onUpdatePage();
                }
              });
            }
          }}>
          REPROVAR
        </Button>,
      );
    }

    if (
      ((hasPermission(['MEDICAO_QUANTITATIVA_EDITAR']) || hasPermission(['MEDICAO_QUANTITATIVA_MARCAR_FINAL'])) &&
        (usuarioLogadoFiscalAlternativoDoContratoMrn === true ||
          usuarioLogadoFiscalDoContratoMrn === true ||
          usuarioLogadoGestorDoContratoMrn === true ||
          usuarioLogadoAdministradorDoContratoMrn === true ||
          usuarioLogadoAdministradorAlternativoDoContratoMrn === true)) ||
      (usuarioLogadoGestorDoContratoFornecedor === true && codStatusMedicao === 1)
    ) {
      actions.push(
        <FormSubmitButton noIcon type="primary">
          <FormatText id="ui.commons.save" uppercase />
        </FormSubmitButton>,
      );
    }

    return actions;
  }, [geralData, medicaoSelected, atualizarSla]);

  const onEditMedicao = (values: any) => {
    const form = new FormData();
    form.append('MedicaoId', medicaoSelected.id);
    form.append('Final', values.final);
    form.append('Periodica', values.periodica);
    form.append('Complementar', values.complementar);
    form.append('Evento', values.evento);
    if (values.descricao) {
      form.append('Descricao', values.descricao);
    }
    form.append('PeriodoInicio', values.periodoInicio);
    form.append('PeriodoFim', values.periodoFim);
    form.append('Confirmada', values.confirmada);
    return EditarMedicao(form).then(data => {
      if (data) {
        if (data.valid === true) {
          atualizarFormularioAbas();
        }
      }
    });
  };

  const handleUpdate = (values: any) => {
    const form = new FormData();
    form.append('AnexoMedicaoId', values.id);
    form.append('Descricao', values.descricao);

    return updateDescricaoAnexoBm(values.id, form);
  };

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['dadosGeraisBoletimMedicao']}
        expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosGeraisBoletimMedicao" header={'Dados gerais do BM'} style={{ border: 0 }}>
          <MasterDetailForm onSubmit={onEditMedicao} initialValues={geralData}>
            <Widget actions={pqActionDadosGerais}>
              <Visibility
                visible={!!medicaoSelected.isMultiplosGestores}
              >
                <Row>
                  <FormInput label="PQ" name="pq" span={2} disabled />
                  <FormInput label="Escopo" name="escopo" span={2} disabled />
                </Row>
              </Visibility>
              <Row>
                <FormInput label="Número" name="numero" span={2} disabled />
                <FormInput label="Status" name="status" span={2} disabled />
                <FormInput label="Número do Aditivo" name="numeroDoAditivo" span={2} disabled />

                <FormDatePicker
                  label="Período inicial"
                  name="periodoInicio"
                  span={2}
                  format="DD/MM/YYYY"
                  disabled={
                    (geralData.statusConcluido && hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR']) ? true : false) ||
                    usuarioLogadoFiscalDoContratoMrn === true ||
                    usuarioLogadoGestorDoContratoMrn === true ||
                    !isMRN
                  }
                />
                <FormDatePicker
                  label="Período final"
                  name="periodoFim"
                  span={2}
                  format="DD/MM/YYYY"
                  disabled={
                    (geralData.statusConcluido && hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR']) ? true : false) ||
                    usuarioLogadoFiscalDoContratoMrn === true ||
                    usuarioLogadoGestorDoContratoMrn === true ||
                    !isMRN
                  }
                />
                <FormSwitch label="Análise de SLA" name="possuiSla" span={2} disabled />
              </Row>


              {codStatusMedicao === 1 &&
                canChangeCancelarDropdown == true &&
                (usuarioLogadoGestorDoContratoMrn || usuarioLogadoGestorDoContratoFornecedor) ? (
                <>
                  <FormSelect
                    name="confirmada"
                    label="Haverá Medição?"
                    span={2}
                    value={medicaoConfirmada}
                    options={medicaoConfirmadaOptions}
                    onSelect={e => updateMedicaoConfirmada(e)}
                  />

                  {showModalCancelarMedicao ? (
                    <Visibility
                      permissions={['MEDICAO_QUANTITATIVA_APROVAR_CANCELAMENTO']}
                    >
                      <ModalJustificativaCancelamentoMedicaoPeloDropdown
                        id={medicaoSelected.id}
                        onUpdatePage={onUpdatePage}
                        setMedicaoConfirmada={setMedicaoConfirmada}
                        setShowModalCancelarMedicao={setShowModalCancelarMedicao}
                      />
                    </Visibility>
                  ) : null}
                </>
              ) : null}

              <fieldset>
                <legend>Tipos de Medição</legend>
                <FormSwitch
                  label="Final"
                  name="final"
                  span={3}
                  disabled={!hasPermission(['MEDICAO_QUANTITATIVA_MARCAR_FINAL'])}
                />
                <FormSwitch
                  label="Periódica"
                  name="periodica"
                  span={3}
                  disabled={
                    geralData.statusCodigo == 8 ||
                    geralData.automatica ||
                    !hasPermission(['MEDICAO_QUANTITATIVA_EDITAR_TIPOS_MEDICAO'])
                  }
                />
                <FormSwitch
                  label="Complementar"
                  name="complementar"
                  span={3}
                  disabled={
                    geralData.statusCodigo == 8 || !hasPermission(['MEDICAO_QUANTITATIVA_EDITAR_TIPOS_MEDICAO'])
                  }
                />
                {geralData.faturamentoDireto ? (
                  <FormSwitch
                    label="Faturamento Direto"
                    name="faturamentoDireto"
                    span={3}
                    disabled
                  />
                ) : null}
                <FormSwitch
                  label="Evento"
                  name="evento"
                  span={3}
                  disabled={
                    geralData.statusCodigo == 8 || !hasPermission(['MEDICAO_QUANTITATIVA_EDITAR_TIPOS_MEDICAO'])
                  }
                />
              </fieldset>

              {geralData.justificativaCancelamentoMedicao && geralData.statusCodigo == 7 ? (
                <FormTextArea
                  label="Justificativa de Cancelamento Medição"
                  name="justificativaCancelamentoMedicao"
                  span={12}
                  rows={3}
                  disabled
                />
              ) : (
                <></>
              )}

              {geralData.descricao ||
                (hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR']) && geralData.statusCodigo !== 8) ? (
                <FormTextArea
                  label="Descrição"
                  name="descricao"
                  span={12}
                  rows={3}
                  disabled={
                    geralData.statusCodigo == 8 || !hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR']) ? true : false
                  }
                />
              ) : (
                <></>
              )}
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="evidenciasGeraisDaMedicao" header={'Evidências Gerais da Medição'} style={{ border: 0 }}>
          <Widget actions={actionAnexosDamedicao}>
            <PerfectScrollbar>
              <InlineEditTable
                columns={columsAnexosDamedicao}
                dataSource={getAllAnexoMedicoesPorMedicaoId}
                key={'id'}
                updateItem={handleUpdate}
                pagination={false}
                disablenotification={false}
              />
            </PerfectScrollbar>
          </Widget>
        </Panel>
      </Collapse>

      <TotalizadorMedicao
        valoresMedicaoAnterior={valoresMedicaoAnterior}
        valoresMedicaoPeriodo={valoresMedicaoPeriodo}
        valoresMedicaoAcumulado={valoresMedicaoAcumulado}
        valoresContratoCriacaoMedicao={valoresContratoCriacaoMedicao}
        valoreMedicaoSaldo={valoreMedicaoSaldo}
      />
    </>
  );
};

export default Medicao;
